import { useState } from "react";
import { getJobsWithContract } from "services";

const useGetJobs = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const doRequest = async () => {
    setIsLoading(true);

    const response = await getJobsWithContract();

    setData(response);

    setIsLoading(false);
  };

  return { data, doRequest, isLoading };
};

export { useGetJobs };
